import NotificationService from '../services/notification-service'

export default {
  install (Vue) {
    Vue.prototype.$notifications = new NotificationService(new Vue())
  },
}
